import React, { useEffect, useState} from "react";
import { connect } from 'react-redux'
import Loading from "../images/loading.gif";
import Typewriter from "typewriter-effect";
import { NavLink } from "react-router-dom";
import Zoom from 'react-reveal/Zoom';
import firebaseDb from "../firebase";
import {  ref, child, get} from "firebase/database";




const Home = (props) => {
  //console.log(props)

  /*useEffect(() => {

    props.dispatch(fetchPosts())
  }, []);*/
 

     const [contactObjects, setContactObjects] = useState({}) 
     const dbRef = ref(firebaseDb);
     const [isLoading, setLoading] = useState(true)

     useEffect(() => {
      get(child(dbRef,'portafolio')).then((snapshot) => {
          if (snapshot.exists()) {
         
           
            setContactObjects({
              ...snapshot.val()
          })

          setLoading(false) 
         
        
           //console.log(snapshot.val());
          } else {
            setContactObjects({})
            console.log("No data available");
          }
        }).catch((error) => {
          console.error(error);
        });
}, []);


  return (
<>
  


    <div>

  

      <Zoom>
     
        <section className="home">

                 {isLoading 
                          ? 
                          <div className="image">
                          
                            <img src={Loading} alt="img"/>
                          </div>
                          : (
                                
                            <div className="image">
                            {Object.keys(contactObjects).map((key) => {
                                return (
                                      <img src={contactObjects[key].img_home} alt="img"/>
                                    );
                                  })}
                           
                            </div>
                            )
                          }
        
                  
                          
                        
  <div className="content">
            <h3>Olá, sou Diego Teran. </h3>
            <h4>
              <Typewriter
                options={{
                  strings: ["Engenheiro de Computação"],
                  autoStart: true,
                  loop: true,
                  deleteSpeed: 140,
                }}
              />
            </h4>
            <p> Apaixonado por ciência da computação sou um profissional com um treinamento de pesquisa que me permite
              atuar competitivamente em diferentes cenários relacionados às Tecnologias</p>

          {/*  <p>
              Apasionado por la informática soy un profesional con una formación investigativa que me permite
              desempeñarme de forma competitiva en diferentes escenarios relacionados con las Tecnologías
          </p>  */} 

            <NavLink to="/about" aria-current="page" className="btn" >
              Sobre Mim <i className="fas fa-user"></i>
            </NavLink>

          </div>

        </section>

      </Zoom>

     {/*  <h1>Usuarios desde Sheets</h1>  {props.usuarios.isFetching
                          ? <SyncLoader />
                          : (
                            <ul>
                              {props.usuarios.posts.map(post => (
                                <li key={post.id}>
                            
                                  { post.name }
                                 
                                </li>
                              ))}
                            </ul>
                          )
                        }*/}
           
    </div>

    </>
  );



}



export default connect((state) => {
  return state

})(Home)
